var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerPlates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 126.667C32.3288 126.667 37.9998 120.996 37.9998 114C37.9998 107.004 32.3288 101.333 25.3332 101.333C18.3376 101.333 12.6665 107.004 12.6665 114C12.6665 120.996 18.3376 126.667 25.3332 126.667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 126.667C32.3288 126.667 37.9998 120.996 37.9998 114C37.9998 107.004 32.3288 101.333 25.3332 101.333C18.3376 101.333 12.6665 107.004 12.6665 114C12.6665 120.996 18.3376 126.667 25.3332 126.667Z",
    stroke: "url(#paint0_linear_16725_938)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 126.667C133.662 126.667 139.333 120.996 139.333 114C139.333 107.004 133.662 101.333 126.667 101.333C119.671 101.333 114 107.004 114 114C114 120.996 119.671 126.667 126.667 126.667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 126.667C133.662 126.667 139.333 120.996 139.333 114C139.333 107.004 133.662 101.333 126.667 101.333C119.671 101.333 114 107.004 114 114C114 120.996 119.671 126.667 126.667 126.667Z",
    stroke: "url(#paint1_linear_16725_938)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2544 114H84.1619C88.8017 114 91.1216 114 92.6746 113.015C94.2275 112.03 95.541 109.244 98.1681 103.672C99.6552 100.518 101.562 97.6029 103.817 94.9999M103.817 94.9999L25.3335 101.333M103.817 94.9999C108.061 90.1004 113.54 86.3036 119.782 84.0806C123.184 82.869 124.885 82.2629 125.459 81.1571C126.033 80.0513 125.61 78.5276 124.764 75.4806L115.071 40.589C113.483 34.8733 112.69 32.0154 110.976 29.9385C109.729 28.4271 108.148 27.2256 106.358 26.4285C103.898 25.3333 100.932 25.3333 95.0002 25.3333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2544 114H84.1619C88.8017 114 91.1216 114 92.6746 113.015C94.2275 112.03 95.541 109.244 98.1681 103.672C99.6552 100.518 101.562 97.6029 103.817 94.9999M103.817 94.9999L25.3335 101.333M103.817 94.9999C108.061 90.1004 113.54 86.3036 119.782 84.0806C123.184 82.869 124.885 82.2629 125.459 81.1571C126.033 80.0513 125.61 78.5276 124.764 75.4806L115.071 40.589C113.483 34.8733 112.69 32.0154 110.976 29.9385C109.729 28.4271 108.148 27.2256 106.358 26.4285C103.898 25.3333 100.932 25.3333 95.0002 25.3333",
    stroke: "url(#paint2_linear_16725_938)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5965 44.3333L63.7679 55.8117C62.8216 57.0417 63.5 58.8116 65.0428 59.1391L74.2907 61.1021C75.9361 61.4513 76.5631 63.4105 75.413 64.6069L64.4588 75.9999",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5965 44.3333L63.7679 55.8117C62.8216 57.0417 63.5 58.8116 65.0428 59.1391L74.2907 61.1021C75.9361 61.4513 76.5631 63.4105 75.413 64.6069L64.4588 75.9999",
    stroke: "url(#paint3_linear_16725_938)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_938",
    x1: 12.6665,
    y1: 101.333,
    x2: 42.7728,
    y2: 109.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_938",
    x1: 114,
    y1: 101.333,
    x2: 144.106,
    y2: 109.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_938",
    x1: 25.3335,
    y1: 25.3333,
    x2: 142.166,
    y2: 63.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_938",
    x1: 63.3335,
    y1: 44.3333,
    x2: 79.3989,
    y2: 46.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlates);
export default __webpack_public_path__ + "static/media/power-plates.fec9781d3438aa88b456e44a352285a5.svg";
export { ForwardRef as ReactComponent };